<script setup lang="ts">
import { ScrollAreaRoot, ScrollAreaViewport, ScrollAreaCorner } from 'radix-vue'
import ScrollBar from './ScrollBar.vue'

const props = defineProps<{
  type?: 'auto' | 'always' | 'scroll' | 'hover'
  scrollHideDelay?: number
  className?: string
}>()
</script>

<template>
  <ScrollAreaRoot
    :type="type ?? 'hover'"
    :scroll-hide-delay="scrollHideDelay ?? 600"
    :class="className"
    class="relative overflow-hidden"
  >
    <ScrollAreaViewport class="h-full w-full rounded-[inherit]">
      <slot />
    </ScrollAreaViewport>
    <ScrollBar />
    <ScrollBar orientation="horizontal" />
    <ScrollAreaCorner />
  </ScrollAreaRoot>
</template>
